import {StringValidacao} from './string';
import {Construtor} from './construtor';

export class GrupoAcesso implements Construtor<GrupoAcesso> {

  public idGrupoAcesso: number;
  public nomeGrupoAcesso: string;
  public idCliente: number;
  public selecionado: boolean;

  constructor(object?: any) {

    if (object !== undefined) {

      if (object instanceof GrupoAcesso) {
        this.copyObject(object);
      } else {
        this.parseFromJson(object);
      }

      return this.modeloCompleto() ? this : null;
    }

    return this;
  }

  get obterIdGrupoAcesso(): number {
    return this.idGrupoAcesso;
  }

  set IdGrupoAcesso(idGrupoAcesso: any) {
    this.idGrupoAcesso = idGrupoAcesso;
  }

  get obterNomeGrupoAcesso(): string {
    return this.nomeGrupoAcesso.slice(0);
  }

  set NomeGrupoAcesso(nomeGrupoAcesso: any) {
    this.nomeGrupoAcesso = StringValidacao.copiarStringValida(nomeGrupoAcesso);
  }

  get obterIdCliente(): number {
    return this.idCliente;
  }

  set IdCliente(idCliente: any) {
    this.idCliente = idCliente;
  }

  copyObject(grupoAcesso: GrupoAcesso): void {

    this.idGrupoAcesso = grupoAcesso.obterIdGrupoAcesso;
    this.nomeGrupoAcesso = grupoAcesso.obterNomeGrupoAcesso;
    this.idCliente = grupoAcesso.obterIdCliente;
  }

  parseFromJson(grupoAcesso: any): void {

    this.IdGrupoAcesso = grupoAcesso.idGrupoAcesso;
    this.NomeGrupoAcesso = grupoAcesso.nomeGrupoAcesso;
    this.IdCliente = grupoAcesso.idCliente;

  }

  modeloCompleto(): boolean {
    return this.nomeGrupoAcesso !== undefined;
  }

  getNewInstance(object?: any): GrupoAcesso {
    return new GrupoAcesso(object);
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/modelos/grupo-acesso.ts